// INSTRUMENT: Work Style Screener (AXIS360 Verify Express · Short-Form Screener)
// Science: IPIP-20 open domain · Big Five Conscientiousness + Agreeableness facets
// Format: 40 Likert items (1-5) · 10 minutes · Traffic light output
// Norms: Global & Indian norm sample (n=7K+)
// Standards: IPIP open license
import { WORK_STYLE_ITEMS, WORK_STYLE_DIMS } from "./questionBank.js";
import { scoreWorkStyle, WS_TRAFFIC, WS_THRESHOLDS, WS_ROLE_PROFILES } from "./scoring.js";
export { WORK_STYLE_DIMS, WS_TRAFFIC, WS_THRESHOLDS, WS_ROLE_PROFILES };

const WorkStyleScreener = {
  id:"work_style", name:"Work Style Screener", shortName:"Work Style",
  icon:"⚡", color:"#059669", bg:"#f0fdf4",
  description:"40-item short-form personality screener using IPIP open-domain constructs. Measures Reliability, Teamwork, Compliance, Stress Tolerance and Service Orientation — the five dimensions most predictive of frontline role performance. Delivers Green/Amber/Red traffic light output for instant shortlisting.",
  desc:"40 items · 10 minutes · Traffic light output · Instant shortlist",
  publisher:"AXIS360 Express", version:"1.0",
  itemCount:40, items:40, timeLimit:10, time:"10 min", timeEstimate:"10 minutes",
  format:"likert", scaleType:"likert-5", isScreener:true, isExpress:true, pricingTier:"volume", creditCost:20,
    pagesOf:20, totalPages:2,
  predicts:["Attendance reliability","Safety compliance","Team integration speed","Customer complaint frequency"],
  questions: WORK_STYLE_ITEMS,
  dims: WORK_STYLE_DIMS,
  score(answers){ return scoreWorkStyle(answers); },
  nineboxAxes:{ x:{label:"Work Style",scaleIds:["ws_r"]}, y:{label:"Work Style",scaleIds:["ws_c"]} },
};
export default WorkStyleScreener;
